export const getRebateRoutePrefix = () =>
  sessionStorage.getItem('application') === 'Sales Rebate' ? 'sales-rebate' : 'supplier-rebate';
